import { render, staticRenderFns } from "./StockPrintKuTag.vue?vue&type=template&id=6537492e&scoped=true&"
import script from "./StockPrintKuTag.vue?vue&type=script&lang=js&"
export * from "./StockPrintKuTag.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintKuTag.vue?vue&type=style&index=0&id=6537492e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537492e",
  null
  
)

export default component.exports